var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',_vm._b({attrs:{"outlined":"","counter":"","rows":"6"},on:{"input":function($event){return _vm.$emit('input', $event)},"blur":function($event){return _vm.$emit('blur', $event)},"focus":function($event){return _vm.$emit('focus', $event)}}},'v-textarea',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }